import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as server from './server';
import * as helpers from './helpers';
import { OTHER_REASON } from '../../constants';

export const useOnSubmit = ({ token, setIsUnsubscribed, isMounted, setError, translate }) => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async ({ duration = 0, description, other }) => {
        try {
            await server.unsubscribeUser({
                token,
                casinoName,
                duration: helpers.getDaysInMilliseconds(duration),
                description: description === OTHER_REASON ? other : description
            });

            isMounted() && setIsUnsubscribed(true);
        } catch (error) {
            isMounted() && setError(translate('error'));
        }
    }, [token, setIsUnsubscribed, setError, casinoName, translate, isMounted]);
};
